// src/components/ResourceStatusHeader.js
import * as React from "react";
import { Box, CircularProgress, IconButton, Tooltip, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import StatusChipRow, { DEFAULT_STATUS_CONFIG } from "./StatusChipRow";
import useStatusCounts from "../hooks/useStatusCounts";

export default function ResourceStatusHeader({
    resource,
    title,
    statusesConfig = DEFAULT_STATUS_CONFIG,
    showRefresh = true,
    subtitle,
}) {
    const statuses = React.useMemo(
        () => statusesConfig.map((cfg) => cfg.status),
        [statusesConfig],
    );
    const resolvedTitle = title ?? resource;
    const { counts, total, loading, error, refresh } = useStatusCounts(resource, {
        statuses,
    });

    if (!resource) {
        return null;
    }

    return (
        <Box sx={{ pb: 2, pt: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        {resolvedTitle}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {loading && <CircularProgress size={18} thickness={5} />}
                {showRefresh && (
                    <Tooltip title="Rafraîchir les compteurs">
                        <span>
                            <IconButton
                                size="small"
                                onClick={refresh}
                                disabled={loading}
                                aria-label="Rafraîchir les compteurs"
                            >
                                <RefreshIcon fontSize="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
            </Box>
            <Box sx={{ mt: 1 }}>
                <StatusChipRow
                    counts={counts}
                    total={total}
                    config={statusesConfig}
                    showTotal
                    totalLabel="Total"
                />
            </Box>
            {error && (
                <Typography variant="caption" color="error">
                    Impossible de charger les compteurs.
                </Typography>
            )}
        </Box>
    );
}
